import React, { useEffect, useState } from "react";

const ScrollingBackground = ({ usePicsum = true }) => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    // Use placeholder images directly to avoid API calls
    // This prevents卡顿 during password verification
    setImages(Array.from({ length: 16 }).map((_, i) => ({
      url: `https://picsum.photos/seed/${i + 100}/300/450`,
      key: i
    })));
  }, [usePicsum]);

  // Prepare columns for masonry-like scroll
  const columns = [[], [], [], [], []];
  images.forEach((img, i) => {
    columns[i % 5].push(img);
  });

  return (
    <div
      style={{
        position: "absolute",
        top: "-20%", // Extend beyond viewport to cover rotation gaps
        left: "-20%",
        width: "140%",
        height: "140%",
        zIndex: 0,
        overflow: "hidden",
        display: "flex",
        gap: "24px",
        transform: "rotate(-8deg)", // Artistic tilt
        opacity: 0.5,
        pointerEvents: "none", // Ensure clicks pass through
      }}
    >
      {columns.map((col, i) => (
        <div
          key={i}
          style={{
            flex: 1,
            position: "relative",
            height: "150%", // Reduced height for better performance
            display: "flex",
            flexDirection: "column",
            gap: "16px", // Reduced gap to fit more content
            // Use transform3d for hardware acceleration
            transform: "translate3d(0, 0, 0)",
            willChange: "transform",
            animation: `scrollColumn-${i % 2 === 0 ? 'up' : 'down'} ${30 + i * 5}s linear infinite`,
          }}
        >
          {/* 
             Render duplicated content 2 times to ensure no gaps during the infinite scroll loop.
             Reduced duplication to improve performance
          */}
          {[...col, ...col].map((img, idx) => (
            <div
              key={`${i}-${idx}`}
              style={{
                width: "100%",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)", // Reduced shadow for better performance
                // Fixed height to ensure stability during loading
                minHeight: "150px", // Reduced height
                background: "rgba(255,255,255,0.05)",
              }}
            >
              <img
                src={img.url}
                alt=""
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                  objectFit: "cover",
                }}
                loading="eager" // Eager loading for background images
              />
            </div>
          ))}
        </div>
      ))}
      <style>
        {
          `
          @keyframes scrollColumn-up {
            0% { transform: translate3d(0, 0, 0); }
            100% { transform: translate3d(0, -50%, 0); }
          }
          @keyframes scrollColumn-down {
            0% { transform: translate3d(0, -50%, 0); }
            100% { transform: translate3d(0, 0, 0); }
          }
          `
        }
      </style>
    </div>
  );
};

export default ScrollingBackground;
